<template>
  <div>
    <div v-if="!remoteData || remoteData.length === 0">
      <md-field>
        <md-skeleton avatar title :loading="remoteDataLoading" :row="8">
          <md-field>
            <md-cell-item>无数据</md-cell-item>
            <md-cell-item v-if="this.remoteError">{{this.remoteError}}</md-cell-item>
          </md-field>
        </md-skeleton>
      </md-field>
    </div>
    <div v-else>
      <md-tabs>
        <md-tab-pane class="content" name="valid" label="当前挂号">
          <md-field v-if="!remoteData.validList || remoteData.validList.length == 0">
            <md-detail-item title="无数据"/>
          </md-field>
          <md-field v-for="order of remoteData.validList" :key="order.id">
            <md-detail-item title="就诊人" :content="order.patientName"/>
            <md-detail-item title="就诊日期" :content="formatDate(order.timeBegin, 'yyyy-MM-dd')"/>
            <md-detail-item title="就诊时间" :content="formatDate(order.timeBegin, 'HH:mm') + ' - ' + formatDate(order.timeEnd, 'HH:mm')"/>
            <md-detail-item title="订单号" :content="order.id"/>
            <md-detail-item title=""><md-button type='primary' size='small' inline @click="onItemClick(order.id)">查看</md-button></md-detail-item>
          </md-field>
        </md-tab-pane>
        <md-tab-pane class="content" name="other" label="历史挂号">
          <md-field v-if="!remoteData.otherList || remoteData.otherList.length == 0">
            <md-detail-item title="无数据"/>
          </md-field>
          <md-field v-for="order of remoteData.otherList" :key="order.id">
            <md-detail-item title="就诊人" :content="order.patientName"/>
            <md-detail-item title="就诊日期" :content="formatDate(order.timeBegin, 'yyyy-MM-dd')"/>
            <md-detail-item title="就诊时间" :content="formatDate(order.timeBegin, 'HH:mm') + ' - ' + formatDate(order.timeEnd, 'HH:mm')"/>
            <md-detail-item title="订单号" :content="order.id"/>
            <md-detail-item title="状态" :content="order.state===1?'已完成':(order.state===2?'已取消':(order.state===4?'已过期':''+order.state))"/>
            <md-detail-item title="">
              <md-button type='primary' size='small' inline @click="onItemClick(order.id)">查看</md-button>
            </md-detail-item>
          </md-field>
        </md-tab-pane>
      </md-tabs>
    </div>
  </div>
</template>

<script>
import { orderList } from '../api/daOrder'
import cookie from "@utils/store/cookie"
// eslint-disable-next-line no-unused-vars
import { formatDate } from '../utils/func'
import { Toast, DetailItem, Field, Button, Icon, Tag, Tabs, TabPane, CellItem, Skeleton } from 'mand-mobile'

export default {
  name: 'OrderView',
  components: {
    [DetailItem.name]: DetailItem,
    [Field.name]: Field,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [CellItem.name]: CellItem,
    [Skeleton.name]: Skeleton
  },
  data () {
    return {
      remoteData: [],
      remoteDataLoading: false,
      remoteError: null
    }
  },
  created () {
    let hospitalId = this.$route.query.h || null
    if (hospitalId === 'all') {
      hospitalId = null
      cookie.remove('hospital')
    }
    if (hospitalId != null) {
      cookie.set('hospital', hospitalId)
    }
    this.loadOrder()
  },
  methods: {
    formatDate (date, fmt) {
      return formatDate(date, fmt)
    },
    onItemClick (orderId) {
      console.log(orderId)
      this.$router.push({
        path: 'order-view',
        query: {
          orderId: orderId
        }
      })
    },
    loadOrder () {
      const hospitalId = cookie.get('hospital') || null
      this.remoteDataLoading = true
      this.remoteError = null
      this.remoteData = []
      orderList(hospitalId).then(res => {
        this.remoteDataLoading = false
        if (res.data && res.status === 200) {
          this.remoteData = res.data
        } else {
          this.remoteError = res.msg
        }
      }).catch(err => {
        this.remoteDataLoading = false
        if (err.msg) {
          this.remoteError = err.msg
        } else {
          this.remoteError = err
        }
        Toast.info('错误：' + JSON.stringify(err))
      })
    }
  }
}
</script>
